import React, { useEffect, useState } from 'react';
import QuoteModuleComponent from './QuoteComponent';
import { useQuotes } from 'utils/methods/quotes';
import { captureException } from '@sentry/react';

const QuoteModuleAdmin = () => {
  const { listenQuotes } = useQuotes();
  const [quotesData, setQuotesData] = useState([]);
  const id = `quotes-${import.meta.env.VITE_APP_STAGE?.trim() === 'prod' ? 'prod' : 'dev'}`;

  useEffect(() => {
    try {
      const unsubscribe = listenQuotes(id, (data) => {
        if (data?.[id]?.data) {
          const parsedData = JSON.parse(data[id].data);
          const sortedData = parsedData.sort((a, b) => {
            const dateA = new Date(a.updated_at || a.created_at || 0);
            const dateB = new Date(b.updated_at || a.created_at || 0);
            return dateB - dateA;
          });
          setQuotesData(sortedData);
        } else {
          setQuotesData([]);
        }
      });
      return () => unsubscribe();
    } catch (error) {
      captureException(`659 Error listening to session changes: ${error}`);
    }
  }, []);

  return <QuoteModuleComponent id={id} quotesData={quotesData} />;
};

export default QuoteModuleAdmin;
